import classNames from "classnames";
import React, { useEffect, useRef } from "react";
import "./context-menu.scss";

export interface ContextMenuItem {
  label: string;
  onSelect: () => void;
  icon?: React.ReactNode;
  danger?: boolean;
  separatorAfter?: boolean;
  shortcut?: string;
}

interface ContextMenuProps {
  x: number;
  y: number;
  items: ContextMenuItem[];
  onClose: () => void;
}

const ContextMenu: React.FC<ContextMenuProps> = ({ x, y, items, onClose }) => {
  const ref = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    const onClick = (event: MouseEvent): void => {
      if (!ref.current?.contains(event.target as Node)) onClose();
    };
    const onKey = (event: KeyboardEvent): void => {
      if (event.key === "Escape") onClose();
    };
    window.addEventListener("mousedown", onClick);
    window.addEventListener("keydown", onKey);
    return () => {
      window.removeEventListener("mousedown", onClick);
      window.removeEventListener("keydown", onKey);
    };
  }, [onClose]);

  return (
    <div ref={ref} className="kuika-context-menu" style={{ left: x, top: y }} role="menu">
      {items.map((item, index: number) => (
        <React.Fragment key={`${item.label}-${index}`}>
          <button
            type="button"
            role="menuitem"
            className={classNames("kuika-context-menu__item", { "kuika-context-menu__item--danger": item.danger })}
            onClick={() => {
              item.onSelect();
              onClose();
            }}
          >
            {item.icon && <span className="kuika-context-menu__icon">{item.icon}</span>}
            <span className="kuika-context-menu__label">{item.label}</span>
            {item.shortcut && <span className="kuika-context-menu__kbd">{item.shortcut}</span>}
          </button>
          {item.separatorAfter && <div className="kuika-context-menu__separator" />}
        </React.Fragment>
      ))}
    </div>
  );
};

export default ContextMenu;
